export const skillData = [
  {
    id: 1,
    skillName: 'Tailwind',
    description: 'Utility-first CSS framework for rapidly building custom designs.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 2,
    skillName: 'React',
    description: 'A JavaScript library for building user interfaces.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 3,
    skillName: 'TypeScript',
    description: 'A typed superset of JavaScript that compiles to plain JavaScript.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 4,
    skillName: 'Leadership',
    description: 'Ability to guide individuals or groups toward goal achievement.',
    contentType: 'Competence',
    actions: '',
  },
  {
    id: 5,
    skillName: 'Communication',
    description: 'Effective verbal and written skills for collaboration.',
    contentType: 'Competence',
    actions: '',
  },
  {
    id: 6,
    skillName: 'Node.js',
    description: "JavaScript runtime built on Chrome's V8 JavaScript engine.",
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 7,
    skillName: 'Problem Solving',
    description: 'Ability to find solutions to complex or difficult issues.',
    contentType: 'Competence',
    actions: '',
  },
  {
    id: 8,
    skillName: 'Project Management',
    description: 'Process of leading the work of a team to achieve goals and meet success criteria.',
    contentType: 'Competence',
    actions: '',
  },
  {
    id: 9,
    skillName: 'Angular',
    description: 'Platform for building mobile and desktop web applications.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 10,
    skillName: 'Vue.js',
    description: 'Progressive JavaScript framework for building user interfaces.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 11,
    skillName: 'Python',
    description: 'Interpreted, high-level, general-purpose programming language.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 12,
    skillName: 'Django',
    description: 'High-level Python web framework that encourages rapid development.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 13,
    skillName: 'Ruby on Rails',
    description: 'Server-side web application framework written in Ruby.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 14,
    skillName: 'Machine Learning',
    description: 'Field of study that gives computers the ability to learn without being explicitly programmed.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 15,
    skillName: 'Data Analysis',
    description: 'Process of inspecting, cleansing, transforming, and modeling data.',
    contentType: 'Skills',
    actions: '',
  },
  {
    id: 16,
    skillName: 'Public Speaking',
    description: 'Process of communicating information to an audience.',
    contentType: 'Competence',
    actions: '',
  },
  {
    id: 17,
    skillName: 'Teamwork',
    description: 'Collaborative effort of a group to achieve a common goal.',
    contentType: 'Competence',
    actions: '',
  },
  {
    id: 18,
    skillName: 'Time Management',
    description: 'Process of planning and exercising conscious control of time spent on specific activities.',
    contentType: 'Competence',
    actions: '',
  },
  {
    id: 19,
    skillName: 'Critical Thinking',
    description: 'Ability to think clearly and rationally, understanding the logical connection between ideas.',
    contentType: 'Competence',
    actions: '',
  },
  {
    id: 20,
    skillName: 'Creativity',
    description: 'Use of imagination or original ideas to create something.',
    contentType: 'Competence',
    actions: '',
  },
]
